import { createRoutine } from 'redux-saga-routines';
import dotProp from 'dot-prop-immutable';
import { keyBy, get, values } from 'lodash';
import { createSelector } from 'reselect';

export const routines = {
  getAllChecklistItemsForDealList: createRoutine(
    'GET_ALL_CHECKLISTITEMS_FORDEAL'
  ),
  getChecklistItemsForQuestionList: createRoutine(
    'GET_ALL_CHECKLISTITEMS_FORQUESTION'
  ),
  getChecklistItemsForDealAndQuestionList: createRoutine(
    'GET_ALL_CHECKLISTITEMS_FORDEALANDQUESTION'
  ),
  getQuestionsList: createRoutine('GET_ALL_QUESTION2'),
  getChecklistForDealList: createRoutine('GET_ALL_CHECKLIST_FORDEAL'),
  saveChecklistItems: createRoutine('SAVE_CHECKLIST'),
  getSections: createRoutine('GET_SECTIONS'),
  get: createRoutine('GET_SECTION'),
  getSectionChecklistItemsForDeal: createRoutine(
    'GET_SECTION_CHECKLISTITEMS_FORDEAL'
  ),
  getLookupItems: createRoutine('GET_LOOKUP_ITEMS'),
  getLookupLists: createRoutine('GET_LOOKUP_LISTS'),
  getSubclassList: createRoutine('GET_SUBCLASS_LIST'),
  getCurrencyList: createRoutine('GET_CURRENCY_LIST'),
  getIndustryFocusList: createRoutine('GET_INDUSTRYFOCUS_LIST'),
  getJurisdicationList: createRoutine('GET_JURISDICATION_LIST'),
  getRightToApprovedFundExtensionList: createRoutine(
    'GET_RIGHTTOAPPROVEDFUNDEXTENSION_LIST'
  ),
  getExpectedSizeList: createRoutine('GET_EXPECTED_SIZE_LIST'),
  getThresholdList: createRoutine('GET_THRESHOLD_LIST'),
  getEntityTypeList: createRoutine('GET_ENTITYTYPE_LIST'),
  getDealsForGpList: createRoutine('GET_DEALS_FORGP_LIST'),

  getNegotiationList: createRoutine('GET_NEGOTIATION_HISTORY_FORQUESTION'),
  createNegotiationHistory: createRoutine('CREATE_NEGOTIATION_HISTORY'),
  editNegotiationHistory: createRoutine('EDIT_NEGOTIATION_HISTORY')
};

const initialState = {
  isAllChecklistItemsForDealLoading: false,
  allChecklistItems: [],

  isChecklistItemsForQuestionLoading: false,
  questionCheckList: [],

  isChecklistItemsForDealAndQuestionLoading: false,
  checklistItems: [],

  isQuestionsLoading: false,
  questionList: [],

  isChecklistForDealLoading: false,
  checkList: [],

  isSectionsLoading: false,

  isSectionChecklistItemsForDealLoading: false,
  sectionChecklistItemsForDealList: [],

  byId: {},

  isLookupItemsLoading: false,
  lookupItems: [],

  isLookupListsLoading: false,
  lookupLists: {},

  isSubclassListLoading: false,
  subclassList: [],

  isCurrencyListLoading: false,
  currencyList: [],

  isIndustryFocusListLoading: false,
  industryFocusList: [],

  isJurisdicationListLoading: false,
  jurisdicationList: [],

  isExpectedSizeListLoading: false,
  expectedSizeList: [],

  isRightToApprovedFundExtensionListLoading: false,
  rightToApprovedFundExtensionList: [],

  isThresholdListLoading: false,
  thresholdListList: [],

  isEntityTypeListLoading: false,
  entityTypeList: [],

  isDealsForGpListLoading: false,
  dealsForGpList: {},

  isNegotiationListLoading: false,
  negotiationList: []
};

function reducer(state = initialState, { type, payload }) {
  let nextState = state;
  switch (type) {
    case routines.saveChecklistItems.TRIGGER:
    case routines.saveChecklistItems.SUCCESS:
    case routines.saveChecklistItems.FAILURE:
      break;
    case routines.getAllChecklistItemsForDealList.TRIGGER:
      nextState = dotProp.set(
        nextState,
        'isAllChecklistItemsForDealLoading',
        true
      );
      break;
    case routines.getAllChecklistItemsForDealList.SUCCESS: {
      nextState = dotProp.set(
        nextState,
        'isAllChecklistItemsForDealLoading',
        false
      );
      nextState = dotProp.set(nextState, 'allChecklistItems', payload);
      break;
    }
    case routines.getAllChecklistItemsForDealList.FAILURE:
      nextState = dotProp.set(
        nextState,
        'isAllChecklistItemsForDealLoading',
        false
      );
      break;

    case routines.getChecklistItemsForQuestionList.TRIGGER:
      nextState = dotProp.set(
        nextState,
        'isChecklistItemsForQuestionLoading',
        true
      );
      break;
    case routines.getChecklistItemsForQuestionList.SUCCESS: {
      nextState = dotProp.set(
        nextState,
        'isChecklistItemsForQuestionLoading',
        false
      );
      nextState = dotProp.set(nextState, 'questionCheckList', payload);
      break;
    }
    case routines.getChecklistItemsForQuestionList.FAILURE:
      nextState = dotProp.set(
        nextState,
        'isChecklistItemsForQuestionLoading',
        false
      );
      break;

    case routines.getChecklistItemsForDealAndQuestionList.TRIGGER:
      nextState = dotProp.set(
        nextState,
        'isChecklistItemsForDealAndQuestionLoading',
        true
      );
      break;
    case routines.getChecklistItemsForDealAndQuestionList.SUCCESS: {
      nextState = dotProp.set(
        nextState,
        'isChecklistItemsForDealAndQuestionLoading',
        false
      );
      nextState = dotProp.set(nextState, 'checkListItems', payload);
      break;
    }
    case routines.getChecklistItemsForDealAndQuestionList.FAILURE:
      nextState = dotProp.set(
        nextState,
        'isChecklistItemsForDealAndQuestionLoading',
        false
      );
      break;

    case routines.getQuestionsList.TRIGGER:
      nextState = dotProp.set(nextState, 'isQuestionsLoading', true);
      break;
    case routines.getQuestionsList.SUCCESS: {
      nextState = dotProp.set(nextState, 'isQuestionsLoading', false);
      nextState = dotProp.set(nextState, 'questionList', payload);
      break;
    }
    case routines.getQuestionsList.FAILURE:
      nextState = dotProp.set(nextState, 'isQuestionsLoading', false);
      break;

    case routines.getChecklistForDealList.TRIGGER:
      nextState = dotProp.set(nextState, 'isChecklistForDealLoading', true);
      break;
    case routines.getChecklistForDealList.SUCCESS: {
      nextState = dotProp.set(nextState, 'isChecklistForDealLoading', false);
      nextState = dotProp.set(nextState, 'checkList', payload);
      break;
    }
    case routines.getChecklistForDealList.FAILURE:
      nextState = dotProp.set(nextState, 'isChecklistForDealLoading', false);
      break;

    case routines.getSections.TRIGGER:
      nextState = dotProp.set(nextState, 'isSectionsLoading', true);
      break;
    case routines.getSections.SUCCESS: {
      nextState = dotProp.set(nextState, 'isSectionsLoading', false);
      nextState = dotProp.set(nextState, 'byId', keyBy(payload, 'id'));
      break;
    }
    case routines.getSections.FAILURE:
      nextState = dotProp.set(nextState, 'isSectionsLoading', false);
      break;
    case routines.get.SUCCESS:
      nextState = dotProp.set(nextState, `byId.${payload.id}`, payload);
      break;

    case routines.getSectionChecklistItemsForDeal.TRIGGER:
      nextState = dotProp.set(
        nextState,
        'isSectionChecklistItemsForDealLoading',
        true
      );
      break;
    case routines.getSectionChecklistItemsForDeal.SUCCESS: {
      nextState = dotProp.set(
        nextState,
        'isSectionChecklistItemsForDealLoading',
        false
      );
      nextState = dotProp.set(
        nextState,
        'sectionChecklistItemsForDealList',
        payload
      );
      break;
    }
    case routines.getSectionChecklistItemsForDeal.FAILURE:
      nextState = dotProp.set(
        nextState,
        'isSectionChecklistItemsForDealLoading',
        false
      );
      break;
    case routines.getLookupItems.TRIGGER:
      nextState = dotProp.set(nextState, 'isLookupItemsLoading', true);
      break;
    case routines.getLookupItems.SUCCESS: {
      nextState = dotProp.set(nextState, 'isLookupItemsLoading', false);
      nextState = dotProp.set(nextState, 'lookupItems', payload);
      break;
    }
    case routines.getLookupItems.FAILURE:
      nextState = dotProp.set(nextState, 'isLookupItemsLoading', false);
      break;

    case routines.getLookupLists.TRIGGER:
      nextState = dotProp.set(nextState, 'isLookupListsLoading', true);
      break;
    case routines.getLookupLists.SUCCESS: {
      nextState = dotProp.set(nextState, 'isLookupListsLoading', false);
      nextState = dotProp.set(nextState, 'lookupLists', payload);
      break;
    }
    case routines.getLookupLists.FAILURE:
      nextState = dotProp.set(nextState, 'isLookupListsLoading', false);
      break;

    case routines.getSubclassList.TRIGGER:
      nextState = dotProp.set(nextState, 'isSubclassListLoading', true);
      break;
    case routines.getSubclassList.SUCCESS: {
      nextState = dotProp.set(nextState, 'isSubclassListLoading', false);
      nextState = dotProp.set(nextState, 'subclassList', payload);
      break;
    }
    case routines.getSubclassList.FAILURE:
      nextState = dotProp.set(nextState, 'isSubclassListLoading', false);
      break;

    case routines.getCurrencyList.TRIGGER:
      nextState = dotProp.set(nextState, 'isCurrencyListLoading', true);
      break;
    case routines.getCurrencyList.SUCCESS: {
      nextState = dotProp.set(nextState, 'isCurrencyListLoading', false);
      nextState = dotProp.set(nextState, 'currencyList', payload);
      break;
    }
    case routines.getCurrencyList.FAILURE:
      nextState = dotProp.set(nextState, 'isCurrencyListLoading', false);
      break;

    case routines.getIndustryFocusList.TRIGGER:
      nextState = dotProp.set(nextState, 'isIndustryFocusListLoading', true);
      break;
    case routines.getIndustryFocusList.SUCCESS: {
      nextState = dotProp.set(nextState, 'isIndustryFocusListLoading', false);
      nextState = dotProp.set(nextState, 'industryFocusList', payload);
      break;
    }
    case routines.getIndustryFocusList.FAILURE:
      nextState = dotProp.set(nextState, 'isIndustryFocusListLoading', false);
      break;

    case routines.getJurisdicationList.TRIGGER:
      nextState = dotProp.set(nextState, 'isJurisdicationListLoading', true);
      break;
    case routines.getJurisdicationList.SUCCESS: {
      nextState = dotProp.set(nextState, 'isJurisdicationListLoading', false);
      nextState = dotProp.set(nextState, 'jurisdicationList', payload);
      break;
    }
    case routines.getJurisdicationList.FAILURE:
      nextState = dotProp.set(nextState, 'isJurisdicationListLoading', false);
      break;

    case routines.getRightToApprovedFundExtensionList.TRIGGER:
      nextState = dotProp.set(
        nextState,
        'isRightToApprovedFundExtensionListLoading',
        true
      );
      break;
    case routines.getRightToApprovedFundExtensionList.SUCCESS: {
      nextState = dotProp.set(
        nextState,
        'isRightToApprovedFundExtensionListLoading',
        false
      );
      nextState = dotProp.set(
        nextState,
        'rightToApprovedFundExtensionList',
        payload
      );
      break;
    }
    case routines.getRightToApprovedFundExtensionList.FAILURE:
      nextState = dotProp.set(
        nextState,
        'isRightToApprovedFundExtensionListLoading',
        false
      );
      break;

    case routines.getThresholdList.TRIGGER:
      nextState = dotProp.set(nextState, 'isThresholdListLoading', true);
      break;
    case routines.getThresholdList.SUCCESS: {
      nextState = dotProp.set(nextState, 'isThresholdListLoading', false);
      nextState = dotProp.set(nextState, 'thresholdListList', payload);
      break;
    }
    case routines.getThresholdList.FAILURE:
      nextState = dotProp.set(nextState, 'isThresholdListLoading', false);
      break;

    case routines.getExpectedSizeList.TRIGGER:
      nextState = dotProp.set(nextState, 'isExpectedSizeListLoading', true);
      break;
    case routines.getExpectedSizeList.SUCCESS: {
      nextState = dotProp.set(nextState, 'isExpectedSizeListLoading', false);
      nextState = dotProp.set(nextState, 'expectedSizeList', payload);
      break;
    }
    case routines.getExpectedSizeList.FAILURE:
      nextState = dotProp.set(nextState, 'isExpectedSizeListLoading', false);
      break;

    case routines.getEntityTypeList.TRIGGER:
      nextState = dotProp.set(nextState, 'isEntityTypeListLoading', true);
      break;
    case routines.getEntityTypeList.SUCCESS: {
      nextState = dotProp.set(nextState, 'isEntityTypeListLoading', false);
      nextState = dotProp.set(nextState, 'entityTypeList', payload);
      break;
    }
    case routines.getEntityTypeList.FAILURE:
      nextState = dotProp.set(nextState, 'isEntityTypeListLoading', false);
      break;

    case routines.getDealsForGpList.TRIGGER:
      nextState = dotProp.set(nextState, 'isDealsForGpListLoading', true);
      break;
    case routines.getDealsForGpList.SUCCESS: {
      nextState = dotProp.set(nextState, 'isDealsForGpListLoading', false);
      nextState = dotProp.set(nextState, 'dealsForGpList', payload);
      break;
    }
    case routines.getDealsForGpList.FAILURE:
      nextState = dotProp.set(nextState, 'isDealsForGpListLoading', false);
      break;

    case routines.getNegotiationList.TRIGGER:
      nextState = dotProp.set(nextState, 'isNegotiationListLoading', true);
      break;
    case routines.getNegotiationList.SUCCESS: {
      nextState = dotProp.set(nextState, 'isNegotiationListLoading', false);
      nextState = dotProp.set(nextState, 'negotiationList', payload);
      break;
    }
    case routines.getNegotiationList.FAILURE:
      nextState = dotProp.set(nextState, 'isNegotiationListLoading', false);
      break;

    case routines.createNegotiationHistory.TRIGGER:
    case routines.createNegotiationHistory.SUCCESS:
    case routines.createNegotiationHistory.FAILURE:
      break;

    case routines.editNegotiationHistory.TRIGGER:
    case routines.editNegotiationHistory.SUCCESS:
    case routines.editNegotiationHistory.FAILURE:
      break;

    default:
      break;
  }
  return nextState;
}

export default reducer;
export const isAllChecklistItemsForDealLoadingSelector = state =>
  state.db.decisions.isAllChecklistItemsForDealLoading;
export const allChecklistItemsForDealSelector = state =>
  state.db.decisions.allChecklistItems;

export const isChecklistItemsForQuestionLoadingSelector = state =>
  state.db.decisions.isChecklistItemsForQuestionLoading;
export const checklistItemsForQuestionSelector = state =>
  state.db.decisions.questionCheckList;

export const isChecklistItemsForDealAndQuestionLoadingSelector = state =>
  state.db.decisions.isChecklistItemsForDealAndQuestionLoading;
export const checklistItemsSelector = state =>
  state.db.decisions.checklistItems;

export const isQuestionsLoadingSelector = state =>
  state.db.decisions.isQuestionsLoading;
export const questionListSelector = state => state.db.decisions.questionList;

export const isChecklistForDealLoadingSelector = state =>
  state.db.decisions.isChecklistForDealLoading;
export const checkListSelector = state => state.db.decisions.checkList;

const sectionIdSelector = (state, props) => props.id;

export const sectionsByIdSelector = state => state.db.decisions.byId;
export const sectionListSelector = createSelector(
  [sectionsByIdSelector],
  byId => values(byId)
);

export const isSectionsLoadingSelector = state =>
  state.db.decisions.isSectionsLoading;
export const sectionSelector = createSelector(
  [sectionsByIdSelector, sectionIdSelector],
  (byId, id) => get(byId, id)
);

export const isSectionChecklistItemsForDealLoadingSelector = state =>
  state.db.decisions.isSectionChecklistItemsForDealLoading;
export const sectionChecklistItemsForDealListSelector = state =>
  state.db.decisions.sectionChecklistItemsForDealList;

export const isLookupItemsLoadingSelector = state =>
  state.db.decisions.isLookupItemsLoading;
export const lookupItemsSelector = state => state.db.decisions.lookupItems;

export const isLookupListsLoadingSelector = state =>
  state.db.decisions.isLookupListsLoading;
export const lookupListsSelector = state => state.db.decisions.lookupLists;

export const isSubclassListLoadingSelector = state =>
  state.db.decisions.isSubclassListLoading;
export const subclassListSelector = state => state.db.decisions.subclassList;

export const isCurrencyListLoadingSelector = state =>
  state.db.decisions.isCurrencyListLoading;
export const currencyListSelector = state => state.db.decisions.currencyList;

export const isIndustryFocusListLoadingSelector = state =>
  state.db.decisions.isIndustryFocusListLoading;
export const industryFocusListSelector = state =>
  state.db.decisions.industryFocusList;

export const isJurisdicationListLoadingSelector = state =>
  state.db.decisions.isJurisdicationListLoading;
export const jurisdicationListSelector = state =>
  state.db.decisions.jurisdicationList;

export const isRightToApprovedFundExtensionListLoadingSelector = state =>
  state.db.decisions.isRightToApprovedFundExtensionListLoading;
export const rightToApprovedFundExtensionListSelector = state =>
  state.db.decisions.rightToApprovedFundExtensionList;

export const isThresholdListLoadingSelector = state =>
  state.db.decisions.isThresholdListLoading;
export const thresholdListListSelector = state =>
  state.db.decisions.thresholdListList;

export const isEntityTypeListLoadingSelector = state =>
  state.db.decisions.isEntityTypeListLoading;
export const entityTypeListSelector = state =>
  state.db.decisions.entityTypeList;

export const isDealsForGpListLoadingSelector = state =>
  state.db.decisions.isDealsForGpListLoading;
export const dealsForGpListSelector = state =>
  state.db.decisions.dealsForGpList;

export const isNegotiationListLoadingSelector = state =>
  state.db.decisions.isNegotiationListLoading;
export const negotiationListSelector = state =>
  state.db.decisions.negotiationList;

export const isExpectedSizeListLoadingSelector = state =>
  state.db.decisions.isExpectedSizeListLoading;
export const expectedSizeListSelector = state =>
  state.db.decisions.expectedSizeList;
